import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { PsychologistService } from '@avanta/shared/services/psychologists';
import { mapBookedContactMethod } from '@avanta/shared/utils/appointments';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { AppointmentService } from 'services/appointments';
import { type Appointment } from 'types/appointments';

export const useFetchAppointmentsHistory = (patientId: string): UseQueryResult<Appointment[]> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_APPOINTMENTS_HISTORY, patientId],
    queryFn: async () => {
      const { data: appointments } = await AppointmentService.getAppointments(patientId);

      return Promise.all(
        appointments.map(async appointment => {
          const [psychologist, center] = await Promise.all([
            PsychologistService.getPsychologist(appointment.psychologistId),
            AppointmentService.getCenterDetails(appointment.backofficeCenterId),
          ]);

          return {
            ...appointment,
            psychologist: { psychologist: psychologist.data },
            bookedContactMethod: mapBookedContactMethod(
              appointment.bookedContactMethod,
              appointment.backofficeCenterId
            ),
            center: center.data,
          };
        })
      );
    },
    enabled: !!patientId,
  });
